import { PropsWithChildren } from "react";

import ErrorScreen from "~/modules/app/screens/ErrorScreen";
import LoadingScreen from "~/modules/app/screens/LoadingScreen";

import useProject from "../../hooks/useCurrentProject";

export default function RequiredProject({ children }: PropsWithChildren<unknown>) {
    const { data, loading, error } = useProject();

    if (error) {
        return <ErrorScreen error={error} />;
    }
    if (loading) {
        return <LoadingScreen />;
    }
    if (data) {
        return children;
    }
}
